<template>
  <li class="menu-item has-child" v-if="menu.children !== undefined ">
    <a href="#" class="menu-link" v-if="first">
      <span :class="menu.icon"></span>
      <span class="menu-text">{{menu.title}}</span>
    </a> <!-- child menu -->
    <a href="#" class="menu-link" v-else>
      <span class="menu-text">{{menu.title}}</span>
    </a>
    <ul class="menu">
      <template v-for="(data, i) in menu.children" >
        <router-link  v-bind:key="i"  tag="li" class="menu-item" :class="{'has-child': data.children!==undefined && data.children.length> 0}" :to="data.path[0]" v-if="data.children === undefined">
          <a class="menu-link" @click="clickMenu">{{data.title}}</a>
        </router-link>
        <template v-else>
          <side-menu :menu="data" v-bind:key="i" :first="false"></side-menu>
        </template>
      </template>

    </ul><!-- /child menu -->
  </li>
  <router-link tag="li" class="menu-item" :to="menu.path[0]" v-else-if="menu.action.includes('view')">
    <a class="menu-link" @click="clickMenu">
      <span :class="menu.icon"></span>
      <span class="menu-text">{{menu.title}}</span>
    </a>
  </router-link>
</template>

<script>
export default {
  name: "SideMenu",
  props:{
    menu:{
      type:Object
    },
    first:{
      type:Boolean
    }
  },
  methods:{
    clickMenu() {
      this.$root.$children[0].$children[0].$children[0].clickMenu()
    },
  }
}
</script>